import {
    CheckCircle,
    Icon,
    Warning,
    WarningOctagon,
} from "@phosphor-icons/react";
import Card from "./Card";
import Typography from "./Typography";
import { RagStatus, ragToBgClassMap } from "../constants";
import clsx from "clsx";

export type RagMetricCardProps = {
    title: string;
    value: number;
    variant: RagStatus;
    disabled?: boolean;
};

const variantToIconMap: { [key in RagStatus]: Icon } = {
    red: WarningOctagon,
    amber: Warning,
    green: CheckCircle,
};

const RagMetricCard = ({ title, value, variant }: RagMetricCardProps) => {
    const Icon = variantToIconMap[variant];
    return (
        <Card className="py-4 px-6">
            <Typography
                variant="title-medium"
                component="h3"
                className={value === 0 ? "text-gray-300" : ""}
            >
                {title}
            </Typography>
            <div className="flex items-end mt-4 justify-between">
                <div className="flex items-center gap-6">
                    <div
                        className={clsx(
                            "rounded-md p-1",
                            value === 0
                                ? "bg-gray-300"
                                : ragToBgClassMap[variant],
                            (variant === "red" || value === 0) && "text-white"
                        )}
                    >
                        <Icon weight="light" size={40} />
                    </div>
                    <Typography
                        variant="display-large"
                        component="p"
                        className={value === 0 ? "text-gray-300" : ""}
                    >
                        {value}
                    </Typography>
                </div>
            </div>
        </Card>
    );
};

export default RagMetricCard;
